module dg.navigation {

    export class NavigationService {

        public constructor(
            private $state: ng.ui.IStateService,
            private $stateRegistry: any,
            private $location: ng.ILocationService,
            private $timeout: ng.ITimeoutService,
            private modalService: dg.modals.ModalService,
            private actionService: dg.actions.ActionService

        ) {

        }

        public getState(link: dg.restfulApi.Link) {
            if (link) {
                let state = this.$state.get().filter(state => {
                    let st = <angular.ui.IState>state;
                    return !!st.apiUrl && st.apiUrl == link.urnTemplate;
                })[0];

                return <angular.ui.IState>state;
            }
        }

        private hasState(link: dg.restfulApi.Link) {
            let state = this.getState(link);
            return !!state;
        }

        public navigate(link: dg.restfulApi.Link, query?: dg.domain.queries.IQueryAction) {

            let state = this.getState(link);
            let navData: ng.ui.IState

            if (!state) {
                if (link.rel == dg.restfulApi.DG_LINK_RELS.action || link.rel == dg.restfulApi.DG_LINK_RELS.confirmationAction) {
                    state = this.$state.get('defaultCommand');
                }
                else if (link.rel == dg.restfulApi.DG_LINK_RELS.export || link.rel == dg.restfulApi.DG_LINK_RELS.external) {
                    state = this.$state.get('defaultExport');
                }
            }

            if (state) {
                navData = dgUtils.ObjectHelperService.mergeDeep({}, state);
            }
            else {
                throw new Error("State can not be found");
            }

            let stateName = state.name;
            let params: any = {};

            if (state.abstract && state.modalOptions) {

                stateName = this.RegisterModalState(navData);
                if (query) {
                    params.query = query;
                }

                params[stateName + '_link'] = link;

                let loadingInstance = this.modalService.open({
                    template: '<div class="loading-modal"><loading /></div>'
                });

                let promise = this.$state.go(stateName, params).finally(() => {
                    loadingInstance.close();
                });

                //return this.$state.target(modalStateName)
                //this.openModal(navData, link);
            } else {
                let queryParams = {};
                if (query) {
                    queryParams = this.actionService.getQueryParams(query);
                }

                queryParams = dgUtils.ObjectHelperService.mergeDeep(queryParams, link.parameters);

                params.queryParams = queryParams;
                params = dgUtils.ObjectHelperService.mergeDeep(params, queryParams);

                this.$state.go(stateName, params);
            }
        }

        private RegisterModalState(navData: ng.ui.IState) {

            var currentStateName = this.$state.current.name;
            var modalStateName = currentStateName + '.' + navData.name;

            if (!this.$stateRegistry.get(modalStateName)) {

                navData.params[modalStateName + '_link'] = null;

                //register the new state under current state
                this.initializeModalState(navData, modalStateName);

                this.$stateRegistry.register(navData);
            }
            return modalStateName;

        }


        private initializeModalState(navData: angular.ui.IState, modalStateName: string) {

            navData.name = modalStateName;
            navData.abstract = false;

            let modalInstance: ng.ui.bootstrap.IModalInstanceService;
            navData["onRetain"] = ($state: ng.ui.IStateService, $transition$) => {
                if ($transition$.ignored()) {

                }
            };

            navData.onEnter = ($uibModal: ng.ui.bootstrap.IModalService, $state: ng.ui.IStateService, $transition$) => {
                let viewId = $transition$.to().name;

                let backdrop = 'static';

                let elementId = $transition$.from().name.split('.').join('-');
                let el = angular.element(`#${elementId}`);


                //this.modalService.open() //resolve viewid
                let settings = dgUtils.ObjectHelperService.mergeDeep({ appendTo: el, template: `<div><div ui-view></div></div>`, backdrop: false }, navData.modalOptions);
                modalInstance = $uibModal.open(settings);

                //

                //modalInstance.closed.then(() => {
                modalInstance.result.finally(() => {
                    if (modalInstance) {
                        modalInstance = null;
                        $state.go('^');
                    }
                }).then(angular.noop, angular.noop);

                return modalInstance.opened;
            }

            navData.onExit = ($transition$) => {
                //$transition$.from().name != $transition$.to().name &&
                if (modalInstance) {
                    modalInstance.close();
                }
            }
        }

        //private openModal(navData: ng.ui.IState, link: dg.restfulApi.Link) {
        //    let loadingInstance = this.modalService.open({
        //        template: '<div class="loading-modal"><loading /></div>'
        //    });

        //    let modalSettings = <ng.ui.bootstrap.IModalSettings>{
        //        controller: navData.controller,
        //        template: navData.template,
        //        templateUrl: navData.templateUrl,
        //        resolve: navData.resolve,
        //    };

        //    if (link.rel == dg.restfulApi.DG_LINK_RELS.confirmationAction) {
        //        modalSettings.size = '';
        //    }

        //    let instance = this.modalService.open(modalSettings);

        //    instance.opened.then(v => {
        //        loadingInstance.close();
        //    });
        //    instance.result.then((result) => {
        //        //if (angular.isDefined(scope.onSuccess)) {
        //        //    scope.onSuccess();
        //        //}
        //    }, (error) => {
        //        //if (angular.isDefined(scope.onError)) {
        //        //    scope.onError();
        //        //}
        //    });
        //}
    }

    angular.module('dg.navigation')
        .service('navigationService', NavigationService);
}